import { useState } from "react";
import { Link } from "react-router-dom";
import { Users as UsersIcon, Plus, ExternalLink, ShieldCheck } from "lucide-react";
import { api } from "@/data/api";
import { useAsync } from "@/hooks/useAsync";
import { PageHeader, StatusBadge, DataTable, DemoBadge, AsyncBoundary, RowsSkeleton, ProjectAvatar } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CreateResourceDialog } from "@/components/common/CreateResourceDialog";
import { demoAction } from "@/lib/demo";

export default function Clients() {
  const { data, loading, error, reload } = useAsync(() => api.getClients());


  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader icon={UsersIcon} title="Clientes" description="Clientes e seus serviços. Cada cliente possui uma visão simplificada no Portal do Cliente."
        breadcrumb={<><span>Organização</span><span>/</span><span className="text-foreground">Clientes</span></>}
        actions={<>
          
          <Link to="/portal"><Button variant="outline" className="border-line bg-transparent hover:bg-white/5" data-testid="clients-portal-preview"><ExternalLink className="h-4 w-4" /> Ver Portal do Cliente</Button></Link>
          <CreateResourceDialog kind="clients" onCreated={reload} />
        </>} />
      <AsyncBoundary loading={loading} error={error} skeleton={<RowsSkeleton />}>
        <DataTable
          columns={[
            { key: "name", header: "Cliente", render: (r) => <div className="flex items-center gap-3"><ProjectAvatar name={r.name} size="sm" /><div><p className="font-medium text-foreground">{r.name}</p><p className="text-xs text-muted-foreground">{r.contact}</p></div></div> },
            { key: "plan", header: "Plano", render: (r) => <span className="rounded border border-line px-2 py-0.5 text-xs text-muted-foreground">{r.plan}</span> },
            { key: "sites", header: "Projetos", align: "center" },
            { key: "services", header: "Serviços", align: "center" },
            { key: "status", header: "Status", render: (r) => <StatusBadge status={r.status} size="sm" /> },
            { key: "actions", header: "", align: "right", render: (r) => (
              <Link to={`/clientes/${r.id}`}><Button size="sm" variant="outline" data-testid={`client-open-${r.id}`}><ShieldCheck className="h-3.5 w-3.5" /> Abrir cliente</Button></Link>
            ) },
          ]}
          rows={data} testid="clients-table" />
      </AsyncBoundary>

    </div>
  );
}
